import { WarningAlert } from '@/components';
import { WALLET } from '@/utils/strings';
const WalletFoundButNoAssetsFoundWarningAlert = () => (
  <WarningAlert
    title={WALLET.WALLET_FOUND_BUT_NO_ASSETS_FOUND_TITLE}
    description={WALLET.WALLET_FOUND_BUT_NO_ASSETS_FOUND_DESCRIPTION}
  />
);
export default WalletFoundButNoAssetsFoundWarningAlert;
